const notImplemented = msg => {throw new Error(msg);};
export default class JobDB {
  atomicSwap(key, value, version) {
    notImplemented("swap"); 
  }
  delete(key, version) {
    notImplemented("delete"); 
  }
  get(key, version) {
    notImplemented("get"); 
  }
  insert(key, value, {ttl}={}) {
    notImplemented("insert"); 
  }
  update(key, value, {ttl}={}) {
    notImplemented("update"); 
  }
  upsert(key, value, {ttl}={}) {
    notImplemented("upsert"); 
  }
  watch(namespace, observer) {
    notImplemented("watch"); 
  }
}
